module.exports = __webpack_public_path__ + "static/img/15.747e196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/15.png
// module id = s0Is
// module chunks = 0